import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { GuestGuard } from './guards/guest.guard';
import { AdminGuard } from './guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'about',
    loadComponent: () => import('./pages/about/about').then((m) => m.About),
  },
  {
    path: 'team',
    loadComponent: () => import('./pages/team/team').then((m) => m.Team),
  },
  {
    path: 'questions',
    loadComponent: () => import('./pages/questions/questions').then((m) => m.Questions),
  },
  {
    path: 'contact',
    loadComponent: () => import('./pages/contact/contact').then((m) => m.Contact),
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/terms/terms').then((m) => m.Terms),
  },
  {
    path: 'privacy',
    loadComponent: () => import('./pages/privacy/privacy').then((m) => m.Privacy),
  },
  // Auth feature module - lazy loaded
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.authRoutes),
    canActivate: [GuestGuard],
  },
  // Legacy auth routes for backwards compatibility
  {
    path: 'login',
    redirectTo: 'auth/login',
  },
  {
    path: 'register',
    redirectTo: 'auth/register',
  },
  {
    path: 'forgot-password',
    redirectTo: 'auth/forgot-password',
  },
  // Profile page
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.component').then((m) => m.ProfileComponent),
    canActivate: [AuthGuard],
  },
  // Admin feature module - lazy loaded
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.adminRoutes),
    canActivate: [AdminGuard],
  },
  // Trishna feature module - lazy loaded
  {
    path: 'trishna',
    loadChildren: () => import('./features/trishna/trishna.routes').then((m) => m.trishnaRoutes),
    canActivate: [AuthGuard],
  },
  // Public trishna detail route
  {
    path: ':id',
    loadComponent: () => import('./pages/trishna-detail/trishna-detail.component').then((m) => m.TrishnaDetailComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
